<template>
    <v-card class="mx-auto" shaped elevation="0" flat>
        <v-card-title>
            Cambio de Contraseña
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-sm>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-row dense align="center" justify="center">
                            <v-col cols="12" sm="8">
                                <v-img src="@/assets/img/password.png" max-height="250" contain></v-img>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="8" v-show="$root.loading.mostrar == false">
                        <v-form ref="form" id="formu">
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Usuario *" color="textbox" v-model="obForm.usuario" outlined
                                        dense :rules="_.concat(requeridoRegla,emailRegla)" />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Nueva Contraseña *" :type="showA ? 'text' : 'password'" color="textbox"
                                        v-model="obForm.contrasena" :append-icon="showA ? 'visibility' : 'visibility_off'" outlined dense
                                        :rules="_.concat(requeridoRegla)" @click:append="showA = !showA" />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Repetir Contraseña *" :type="showB ? 'text' : 'password'" color="textbox"
                                        v-model="obForm.repetirContrasena" :append-icon="showB ? 'visibility' : 'visibility_off'" outlined dense
                                        :rules="_.concat(requeridoRegla)" @click:append="showB = !showB" />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="text-right">
                                    <v-btn rounded dark color="primary" @click="guardar" :disabled="disabled">Cambiar
                                        Contraseña</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'WindowItemCambioContraseniaComponent',
        props:{
            active:{
                type:Boolean,
                default:false
            }
        },
        data: () => ({
            obForm: {
                usuario: null,
                contrasena: null,
                repetirContrasena: null
            },
            disabled: false,
            showA: false,
            showB: false,
        }),
        mounted(){
            var i = this.$refs.form;
            this.$root.loading.mostrar = true;
            if(!_.isUndefined(i) && !_.isNull(i)){
                setTimeout(() => {
                    document.getElementById("formu").reset();
                    document.getElementById("formu").reset();
                    i.reset();
                    this.$root.loading.mostrar = false;
                }, 2000); 
            }
        },
        watch:{
            active(val){
                var i = this.$refs.form;
                
                if(!_.isUndefined(i) && !_.isNull(i)){
                    document.getElementById("formu").reset();
                    document.getElementById("formu").reset();
                    i.reset();
                }
            }
        },
        methods: {
            guardar() {
                try {
                    this.disabled = true;
                    if (!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                    if (!_.isEqual(this.obForm.contrasena, this.obForm.repetirContrasena))
                    throw 'Las contraseñas no coinciden, vuelva a ingresarlas por favor.';

                    var error = 'E';

                    var objeto = {
                        opcion: 'U',
                        usuario: this.obForm.usuario,
                        contrasena: this.obForm.contrasena,
                        idUsuario: _.get(this.$root,['obUsuario','idUsuario'],null),
                        idEstado:1
                    };

                    axios.post(`${BASE_URI}administrador/usuario/insertOrUpdate`, objeto)
                        .then((r) => {
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.toNumber(_.get(r, ['data', 'data', '0', 'filas_afectadas'], 0)) == 0) {
                                error = 'I';
                                throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion);
                            }
                            localStorage.clear();
                            axios.defaults.headers.common['Authorization'] = null;
                            mensajeAlertaTiempo('Actualización con exito, debe ingresar de nuevo al sistema.', 'S');
                            setTimeout(() => {
                                this.$router.push('/');
                            }, 300);
                        })
                        .catch((e) => {
                            mensajesAlerta(e, error);
                            this.disabled = false;
                            setTimeout(() => {
                                document.getElementById("formu").reset();
                                document.getElementById("formu").reset();
                            }, 2000); 
                        });

                } catch (error) {
                    mensajesAlerta(error, 'I');
                    this.disabled = false;
                    setTimeout(() => {
                        document.getElementById("formu").reset();
                        document.getElementById("formu").reset();
                    }, 2000); 
                }
            }
        },
    }
</script>
